import { SUBMODULE_TYPE } from '@constants/constants';
import { getDeepLinkSubmodule } from '../../DeepLinkRedirect/utils';
import { SignupVariant } from '../constants';

/** Sign-up copy depends on the submodule the user was deep-linked to from the website, if any. */
const getVariant = (): SignupVariant =>
  getDeepLinkSubmodule() === SUBMODULE_TYPE.MARKET_SCAN
    ? SignupVariant.MARKET_SCAN
    : SignupVariant.DEFAULT;

export default getVariant;
